const landingPage = {
    init() {
        const browseSubjectsBtn = document.getElementById('id-landing-control');
        const accordionBody = document.querySelector('.browse-subjects__list');

        if (!browseSubjectsBtn || !accordionBody) return;

        const elementTextOpen = browseSubjectsBtn?.dataset?.open;
        const elementTextClose = browseSubjectsBtn?.dataset?.close;

        /**
         * This function to change the text when the accordion opened or closed
         * I'm using here observerDom to watch the accordionBody
         * @pram {Event} Click event
         * @pram {String} elementTextOpen
         * @pram {String} elementTextClose
         * @pram {Element} accordionBody
         */
        browseSubjectsBtn.addEventListener('click', () =>
            this.toggleText(event, elementTextOpen, elementTextClose, accordionBody)
        );

        /**
         * Truncate book titles function
         * @pram {String} The Selector
         * @pram {Object} Truncate Options
         */

        this.truncateBookTitle('.cover-image__details .serial-title', {
            lines: 3,
            type: 'text',
            seeMoreLink: false,
        });
    },
    toggleText(event, open, close, accordionBody) {
        const element = event.currentTarget;

        const observer = new MutationObserver((mutationsList, observer) => {
            const mutationDisplay = mutationsList[0]?.target?.style?.display;
            if (!mutationDisplay) return;
            if (mutationDisplay === 'block') {
                element.textContent = close;
            } else {
                element.textContent = open;
            }
        });

        observer.observe(accordionBody, {attributes: true});

        if (element.textContent === close) observer.disconnect();
    },
    truncateBookTitle(selector, options) {
        const isBooksSlider = document.querySelector('.journal-slider-wrapper div[data-slider-vport]');
        if (isBooksSlider) {
            $(selector).truncate(options);
        } else {
            $('.journal-slider-wrapper').on('initialized.owl.carousel', function (event) {
                $(selector).truncate(options);
            });
        }
    },
};

UX.landingPage = landingPage;
